(() => {
  const saladHandles = ['salad-shirazi-persialainen-kurkku-tomaattisalaatti', 'kaalisalaatti'];
  const drinkHandles = ['lehmus-suodatinkahvi', 'khakshir-sahramilla', 'tokhm-e-sharbati-basilikansiemenjuoma-sahrami-ja-sitruuna', 'doogh-suolainen-jogurttijuoma'];
  function init(root) {
    if (root.dataset.ready) return;
    const source = root.querySelector('[data-package-data]');
    const calendar = root.closest('[data-upupa-cal]');
    if (!source || !calendar) return;
    const data = JSON.parse(source.textContent);
    const products = data.products;
    const labels = data.labels;
    const money = value => new Intl.NumberFormat(data.locale, { style:'currency', currency:data.currency || 'EUR' }).format(value / 100);
    const states = [];
    let currentIso = '';
    function property(container, name, value) {
      const input = document.createElement('input');
      input.type = 'hidden'; input.name = `properties[${name}]`; input.value = value;
      container.append(input);
    }
    function variantText(product, variant) {
      return product.title + (variant.title === 'Default Title' ? '' : ` · ${variant.title}`);
    }
    function optionField(container, title, entries, id, onChange) {
      const label = document.createElement('label'); label.textContent = title;
      const select = document.createElement('select'); select.required = true; select.id = id;
      const empty = document.createElement('option'); empty.value = ''; empty.textContent = labels.choose; empty.disabled = true; empty.selected = true; select.append(empty);
      entries.forEach(entry => {
        const option = document.createElement('option'); option.value = String(entry.variant.id); option.textContent = entry.text; option.disabled = !entry.variant.available; select.append(option);
      });
      label.append(select); container.append(label); select.addEventListener('change', onChange);
      return select;
    }
    root.querySelectorAll('[data-package-kind]').forEach((card, cardIndex) => {
      const form = card.querySelector('form[data-package-form]');
      const kind = card.dataset.packageKind;
      const state = { card, form, kind, entries:[], regular:0, price:0, valid:false };
      states.push(state);
      form.addEventListener('submit', event => {
        update(state);
        if (!state.valid || !form.reportValidity()) { event.preventDefault(); event.stopImmediatePropagation(); }
      }, true);
      state.build = row => {
        const container = form.querySelector('[data-package-choices]'); container.replaceChildren();
        state.entries = [];
        const add = (product, quantity, key, chosenVariant, choices) => {
          if (!product) { state.entries.push({ missing:true }); return; }
          const item = { product, quantity, key, fixed:chosenVariant || null };
          const variants = choices || product.variants;
          if (!chosenVariant && variants.length > 1) item.select = optionField(container, key, variants.map(variant => ({variant,text:variant.title})), `${form.getAttribute('id')}-${state.entries.length}`, () => update(state));
          else item.fixed = chosenVariant || variants[0];
          state.entries.push(item);
        };
        add(row[0], 1, labels.main + (kind === 'family' ? ' 1' : ''));
        if (kind === 'family') add(row[0], 1, labels.main + ' 2');
        add(products[saladHandles[0]], 1, labels.salad + (kind === 'family' ? ' 1' : ''));
        if (kind === 'family') {
          add(products[saladHandles[1]], 1, labels.salad + ' 2');
          add(row[2], 1, labels.light + ' 1'); add(row[3], 1, labels.light + ' 2');
          add(row[1], 1, labels.soup, row[1]?.variants.find(v => v.title === '1 l'));
          add(row[4], 1, labels.dessert);
          add(products[drinkHandles[3]], 2, labels.doogh);
          add(products[drinkHandles[1]], 1, labels.khakshir);
          add(products[drinkHandles[2]], 1, labels.basil);
        } else {
          const drinks = drinkHandles.flatMap((handle, i) => (products[handle]?.variants || []).map(variant => ({variant,product:products[handle],text:[labels.coffee,labels.khakshir,labels.basil,labels.doogh][i] + (variant.title === 'Default Title' ? '' : ` · ${variant.title}`)})));
          const item = { quantity:1, key:labels.drink, options:drinks };
          item.select = optionField(container, labels.drink, drinks, `${form.getAttribute('id')}-drink`, () => update(state)); state.entries.push(item);
        }
        add(row[5], 1, labels.sweet, row[5]?.variants[0]);
        update(state);
      };
    });
    function selected(item) {
      if (item.missing) return null;
      if (item.options) return item.options.find(x => String(x.variant.id) === item.select.value) || null;
      const variant = item.fixed || item.product.variants.find(v => String(v.id) === item.select?.value);
      return variant ? {product:item.product,variant} : null;
    }
    function update(state) {
      const {card,form,kind} = state;
      const API = window.UPUPA_TILAUS;
      if (!API || !currentIso) return;
      const menu = API.data();
      const day = Math.round((API.isoToUtc(currentIso) - API.isoToUtc(menu.anchor || menu.open)) / 86400000);
      const index = ((day % menu.cycle) + menu.cycle) % menu.cycle;
      const slot = Math.floor(index / 7) * 2 + (index % 7 < 3 ? 0 : 1);
      const sku = `UPUPA-XXL-W${Math.floor(index / 7)+1}-${index % 7 < 3 ? 'A' : 'B'}`;
      const target = kind === 'lunch' ? data.lunch.variants[0] : data.family.variants.find(v => v.sku === sku);
      const chosen = state.entries.map(item => ({item,chosen:selected(item)}));
      const priced = chosen.map(({item,chosen:choice}) => ({item,chosen:choice || (item.options?.[0] || (item.product ? {product:item.product,variant:item.fixed || item.product.variants[0]} : null))}));
      const regular = priced.reduce((sum,{item,chosen:choice}) => sum + (choice?.variant.price || 0) * item.quantity,0);
      const expected = kind === 'lunch' ? 1800 : Math.max(0, regular - 800);
      state.valid = !!target?.available && target.price === expected && priced.every(({chosen:choice})=>choice?.variant.available) && !API.dateProblem(card.dataset.handle,currentIso);
      state.price = target?.price || expected; state.regular = regular;
      form.querySelector('[name="id"]').value = target?.id || '';
      form.querySelector('[data-upupa-iso]').value = currentIso;
      form.querySelector('[data-upupa-label]').value = API.propLabel(API.isoToUtc(currentIso));
      form.querySelector('[data-package-slot]').value = slot;
      const properties = form.querySelector('[data-package-properties]'); properties.replaceChildren();
      const list = form.querySelector('[data-package-contents]'); list.replaceChildren();
      priced.forEach(({item,chosen:choice}) => {
        if (!choice) return;
        const li = document.createElement('li');
        const link = document.createElement('a'); link.href = choice.product.url; link.textContent = `${item.quantity} × ${variantText(choice.product,choice.variant)}`;
        li.append(link); list.append(li);
      });
      chosen.forEach(({item,chosen:choice}) => { if (choice) property(properties,item.key,`${item.quantity} × ${variantText(choice.product,choice.variant)}`); });
      property(properties,'_upupa_package_version','2026-10-21');
      property(properties,'_upupa_package_components',chosen.filter(x=>x.chosen).map(({item,chosen:choice})=>`${choice.variant.id}:${item.quantity}`).join(','));
      card.querySelector('[data-package-summary-price]').textContent = money(state.price);
      form.querySelector('[data-package-regular]').textContent = money(regular);
      form.querySelector('[data-package-price]').textContent = money(state.price);
      form.querySelector('[data-package-saving]').textContent = (kind === 'family' ? labels.family_saving : labels.saving).replace('{amount}',money(regular-state.price));
      const warning = form.querySelector('[data-package-warning]'); warning.hidden = state.valid; warning.textContent = state.valid ? '' : labels.unavailable;
      form.querySelector('[type="submit"]').disabled = !state.valid;
    }
    function render(iso) {
      if (!iso || iso === currentIso || !window.UPUPA_TILAUS) return;
      const API = window.UPUPA_TILAUS;
      currentIso = iso;
      root.querySelector('[data-package-date]').textContent = API.longLabel(API.isoToUtc(iso));
      const row = API.menuHandles(API.isoToUtc(iso)).slice(0,6).map(handle => products[handle]);
      states.forEach(state => state.build(row));
    }
    calendar.addEventListener('upupa:daychange',event=>render(event.detail.iso));
    root.dataset.ready = 'true';
    render(calendar.querySelector('[data-el="menu"] [data-upupa-iso]')?.value);
  }
  function scan(){document.querySelectorAll('[data-upupa-packages]').forEach(init);}
  if(document.readyState === 'loading')document.addEventListener('DOMContentLoaded',scan,{once:true});else scan();
  document.addEventListener('shopify:section:load',scan);
})();

